export default {
  'oper-logs.query.title': 'Operation Module',
  'oper-logs.query.title.placeholder': 'Enter operation module',
  'oper-logs.query.businessType': 'Business Type',
  'oper-logs.query.businessType.placeholder': 'Select business type',
  'oper-logs.query.operName': 'Operator Name',
  'oper-logs.query.operName.placeholder': 'Enter operator name',
  'oper-logs.query.status': 'Operation Status',
  'oper-logs.query.status.placeholder': 'Select operation status',
  'oper-logs.query.status.success': 'Success',
  'oper-logs.query.status.fail': 'Fail',
  'oper-logs.column.expand.reqUrl': 'Request URL',
  'oper-logs.column.expand.reqMethod': 'HTTP Method',
  'oper-logs.column.expand.reqParams': 'Request Parameters',
  'oper-logs.column.expand.method': 'Execution Method',
  'oper-logs.column.expand.respResult': 'Response Result',
  'oper-logs.column.expand.deptName': 'Operator Department',
  'oper-logs.column.expand.errorMsg': 'Error Message',
  'oper-logs.column.expand.errorMsg.view': 'View Error Stack',
  'oper-logs.column.title': 'Operation Module',
  'oper-logs.column.businessType': 'Business Type',
  'oper-logs.column.operName': 'Operator',
  'oper-logs.column.reqIp': 'Request IP',
  'oper-logs.column.reqRegion': 'Request Region',
  'oper-logs.column.browser': 'Browser',
  'oper-logs.column.os': 'Operating System',
  'oper-logs.column.status': 'Operation Result',
  'oper-logs.column.status.success': 'Success',
  'oper-logs.column.status.fail': 'Fail',
  'oper-logs.column.createTime': 'Operation Time',
  'oper-logs.dialog.title': 'Error Stack',
  'oper-logs.dialog.noContent': 'No stack information available',
}
